<template src="./Add.html"></template>

<script>
// import { showAlert } from "@/utils/helpers";

export default {
  created() {
    this.$store.dispatch("lookups/getDoctors");

  },
  computed: {
    medicines() {
      return [...this.medicinesList, { label: "إضافة دواء جديد...", value: "add_new" }];
    },
    doctors() {
      return [
        ...this.$store.state.lookups.doctors];
    },

  },
  data() {
    return {
      medicinesList: [],
      vm: {
        doctorId: null,
        medicineId: null,
        quantity: null,
      },
      showAddMedicineDialog: false,
      newMedicineName: "",

    };
  },
  methods: {
    handleMedicineChange() {
      if (this.vm.medicineId === "add_new") {
        this.showAddMedicineDialog = true;
      }
    },
    async saveNewMedicine() {
      this.$store.dispatch("doctorsStock/add", {
        doctorId: this.vm.doctorId,
        medicineName: this.newMedicineName,
      }).then(res => {
        this.medicinesList.unshift(res)
      });

      this.showAddMedicineDialog = false;
    },
    getMedicines() {
      this.$store.dispatch("doctorsStock/getMedicines", this.vm.doctorId).then(res => {
        this.medicinesList = res
      });

    },
    confirm() {
      this.$store
        .dispatch("doctorsStock/addStock", this.vm)
        .then(() => {
          this.back();
        })
        .catch(() => { });
    },

    back() {
      this.$emit("back");
    },
  },
};
</script>